export default __webpack_public_path__ + "2a281fdaae8df71775277bf9bc60b1b1.svg";